const steps = [
  {
    title: 'Describe the issue',
    text: 'Tell us what you were doing—install, upgrade, sync, or restore—and what you see on screen.',
  },
  {
    title: 'Follow guided steps',
    text: 'We share clear instructions tailored to Windows or Mac so you can move forward safely.',
  },
  {
    title: 'Confirm it works',
    text: 'Once your tree opens cleanly again, we help you verify backups and next best practices.',
  },
];

export default function HowItWorks() {
  return (
    <section className="t7-section t7-section--white" id="how-it-works">
      <div className="container">
        <div className="t7-head t7-head--rail">
          <p className="t7-kicker">Process</p>
          <h2 className="t7-title">How live chat support works</h2>
          <p className="t7-lead">
            Three simple steps from question to resolution—built around chat, not phone calls.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-6">
          {steps.map((step, index) => (
            <div key={step.title} className="relative">
              <div className="hidden md:block absolute top-5 left-[calc(50%+2rem)] right-[-1.5rem] h-px bg-[#c5d9cb] last:hidden" />
              <div className="flex flex-col items-start">
                <span className="font-serif text-4xl text-[#15803d]/35 mb-3">{String(index + 1).padStart(2, '0')}</span>
                <h3 className="font-serif text-xl text-[#14201a] mb-2">{step.title}</h3>
                <p className="text-[#4d5c54] text-[15px] leading-relaxed m-0">{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
